// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"SelfiesTip_style_b-icon-warning__guKhH","wrapper":"SelfiesTip_style_wrapper__hnm6d","rotate":"SelfiesTip_style_rotate__ySMmG"};